import EducationMasterList from "./EducationMasterList";

const AllEducationCategory = () => (
  <EducationMasterList
    title="Education Categories"
    addPath="/add-education-category"
    editPath="/edit-education-category"
    listEndpoint="/admin/all-education-category-fillter"
    deleteEndpoint="/admin/delete-education-category"
    responseKey="EducationCategory"
  />
);

export default AllEducationCategory;
